import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import CommonModal from './CommonModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingModal',
  setup(__props, { expose: __expose }) {

const loadingModal = ref<InstanceType<typeof CommonModal>>();

__expose({
  open: () => {
    loadingModal.value?.open();
  },
  close: () => {
    loadingModal.value?.close();
  },
});

const __returned__ = { loadingModal, CommonModal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})